import { render, staticRenderFns } from "./ExternalAccess.vue?vue&type=template&id=2b3102a9&"
import script from "./ExternalAccess.vue?vue&type=script&lang=ts&"
export * from "./ExternalAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports